<div class="border-grey-light header-container">
  <div class="row gap-22 mobile-row">
    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>
  </div>

  <div class="row d-flex justify-content-end mg-top-8">
    <p>Passo 1 de 3</p>
  </div>
  <h5 class="mg-top-16 mg-bottom-16">Finalização do cadastro</h5>
  <p class="p-text-grey mg-bottom-32">
    Complete as informações necessárias para começar a operar na plataforma.
  </p>
</div>

<div class="padding-16">
  <div class="row mg-bottom-16">
    <h6 class="font-mobile">Dados pessoais</h6>
  </div>

  <div class="row d-flex justify-content-between">
    <p class="p-text-grey">Informe os seus dados pessoais.</p>
    <p class="p-text-grey">* Campos obrigatórios</p>
  </div>
</div>

<form [formGroup]="individualForm">
  <div class="row">
    <div class="col-md-8">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Nome Completo</mat-label>
        <input
          matInput
          formControlName="name"
          type="text"
          class=""
          name="name"
          required
        />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>CPF</mat-label>
        <input
          matInput
          formControlName="cpf"
          type="text"
          mask="000.000.000-00"
          class=""
          name=""
          required
        />
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Data de nascimento</mat-label>

        <input
          matInput
          formControlName="birthday"
          [matDatepicker]="dateOfBirthDatePicker"
        />

        <mat-datepicker-toggle matPrefix [for]="dateOfBirthDatePicker">
        </mat-datepicker-toggle>

        <mat-datepicker #dateOfBirthDatePicker [startAt]="startDate">
        </mat-datepicker>
        <mat-error
          *ngIf="
            individualFormControl.birthday.touched &&
            individualFormControl.birthday.errors?.required
          "
        >
          Data de nascimento obrigatória</mat-error
        >
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Nacionalidade</mat-label>
        <input
          matInput
          formControlName="nacionality"
          type="text"
          class=""
          name=""
          required
        />
        <mat-error
          *ngIf="
            individualFormControl.nacionality.touched &&
            individualFormControl.nacionality.errors?.required
          "
        >
          Nacionalidade obrigatória</mat-error
        >
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Gênero</mat-label>
        <mat-select formControlName="sex">
          <mat-option value="M">Masculino</mat-option>
          <mat-option value="F">Feminino</mat-option>
          <mat-option value="O">Outros / não quero dizer</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-error
        *ngIf="
          individualFormControl.sex.touched &&
          individualFormControl.sex.errors?.required
        "
      >
        Gênero obrigatório</mat-error
      >
    </div>
  </div>
  <div class="col-md-12">
    <div class="row d-flex">
      <mat-radio-group
        class="w-100"
        formControlName="isPublicAgent"
        (change)="
          requiredJob(individualForm, individualForm.value.isPublicAgent)
        "
      >
        <div class="row-question p-text-grey">
          <mat-label>É Agente Público?</mat-label>
        </div>

        <div class="row d-flex radio-input align-items-center">
          <div class="radios">
            <mat-radio-button [value]="false">Não</mat-radio-button>
            <mat-radio-button [value]="true">Sim</mat-radio-button>
          </div>
          <div class="col-md">
            <ng-container *ngIf="individualForm.value.isPublicAgent">
              <mat-form-field appearance="outline">
                <mat-label>Cargo e desde quando</mat-label>
                <input
                  matInput
                  formControlName="publicAgentInformation"
                  type="text"
                  class=""
                  maxlength="20"
                  name="publicAgentInformation"
                  required
                />
                <mat-error
                  *ngIf="
                    individualForm.controls.publicAgentInformation.touched &&
                    individualForm.controls.publicAgentInformation.errors
                      ?.required
                  "
                >
                  Cargo e desde quando obrigatório
                </mat-error>
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </mat-radio-group>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <h6 class="font-mobile">Informações financeiras e patrimoniais</h6>

      <mat-form-field class="mg-top-16" appearance="outline">
        <mat-label>Renda anual</mat-label>
        <input
          matInput
          formControlName="annualBilling"
          type="text"
          class=""
          name=""
          required
          currencyMask
          min="1"
          [options]="{
            prefix: 'R$' + ' ',
            thousands: '.',
            decimal: ','
          }"
        />

        <mat-error
          class="text-danger"
          *ngIf="
            individualForm.controls['annualBilling'].touched &&
            individualForm.controls['annualBilling'].errors?.required
          "
        >
          Renda anual obrigatória
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="col-md-12">
    <div class="row mg-bottom-16">
      <h6 class="font-mobile">Endereço</h6>
    </div>

    <div class="row d-flex">
      <mat-radio-group
        class="w-100"
        formControlName="isResidentAbroad"
        (change)="
          requiredAbroad(individualForm, individualForm.value.isResidentAbroad)
        "
      >
        <div class="row-question p-text-grey">
          <mat-label>Reside no exterior?</mat-label>
        </div>

        <div class="row d-flex radio-input align-items-center">
          <div class="radios radio-input-reside">
            <mat-radio-button [value]="false">Não</mat-radio-button>
            <mat-radio-button [value]="true">Sim</mat-radio-button>
          </div>


          <div class="col-md-4" *ngIf="individualForm.value.isResidentAbroad">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>País que reside</mat-label>
              <mat-select
                (selectionChange)="changeCountry($event)"
                formControlName="country"
                required
                #singleSelect
              >
                <mat-option>
                  <ngx-mat-select-search
                    placeholderLabel="País que reside"
                    noEntriesFoundLabel="Nenhum resultado encontrado"
                    [formControl]="countryListFilterCtrl"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let country of filteredCountryList | async"
                  [value]="country.nome"
                >
                  {{ country.nome }}
                </mat-option>
              </mat-select>
              <mat-error
                class="text-danger"
                *ngIf="
                  individualForm.controls['country'].touched &&
                  individualForm.controls['country'].errors?.required
                "
              >
                País que reside obrigatório
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div>
          <ng-container *ngIf="individualForm.value.isResidentAbroad">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Endereço</mat-label>
              <input
                matInput
                formControlName="line1"
                type="text"
                class=""
                maxlength="20"
                name="line1"
                required
              />
              <mat-error
                *ngIf="
                  individualForm.controls.line1.touched &&
                  individualForm.controls.line1.errors?.required
                "
              >
                Endereço obrigatório
              </mat-error>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="!individualForm.value.isResidentAbroad">
            <div class="row">
              <div class="col-md-2 no-pd-left">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>CEP</mat-label>
                  <input
                    (input)="setAddress(individualForm)"
                    matInput
                    type="tel"
                    maxlength="10"
                    mask="00000-000"
                    placeholder="00000-000"
                    formControlName="postalCode"
                    type="text"
                    name=""
                    
                  />
                  <mat-error
                    *ngIf="
                      individualForm.controls.postalCode.touched &&
                      individualForm.controls.postalCode.errors?.required
                    "
                  >
                    CEP obrigatório
                  </mat-error>
                </mat-form-field>
                <span
                  *ngIf="loadingCep"
                  class="spinner-border spinner-border-sm mg-top-20"
                ></span>
              </div>
              <div class="col-md-6 no-pd-left">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Endereço</mat-label>
                  <input
                    matInput
                    formControlName="line1"
                    type="text"
                    class=""
                    name=""
                    required
                  />
                  <mat-error
                    *ngIf="
                      individualForm.controls.line1.touched &&
                      individualForm.controls.line1.errors?.required
                    "
                  >
                    Endereço obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4 no-pd-left">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Número</mat-label>
                  <input
                    matInput
                    formControlName="number"
                    oninput="validity.valid||(value='');"
                    type="number"
                    class=""
                    name=""
                    
                  />
                  <mat-error
                    *ngIf="
                      individualForm.controls.number.touched &&
                      individualForm.controls.number.errors?.required
                    "
                  >
                    Número obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-2 no-pd-left">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Bairro</mat-label>
                  <input
                    matInput
                    formControlName="line3"
                    type="text"
                    class=""
                    name="line3"
                    required
                  />
                  <mat-error
                    *ngIf="
                      individualForm.controls.line3.touched &&
                      individualForm.controls.line3.errors?.required
                    "
                  >
                  Bairro obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4 no-pd-left">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Complemento</mat-label>
                  <input
                    matInput
                    formControlName="complement"
                    type="text"
                    class=""
                    name=""
                  />
                </mat-form-field>
              </div>

              <div class="col-md-3 no-pd-left">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Cidade</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    type="text"
                    class=""
                    name=""
                    
                  />
                  <mat-error
                    *ngIf="
                      individualForm.controls.city.touched &&
                      individualForm.controls.city.errors?.required
                    "
                  >
                    Cidade obrigatória
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-3 no-pd-left">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Estado</mat-label>
                  <input
                    matInput
                    formControlName="state"
                    type="text"
                    class=""
                    name=""
                    
                  />
                  <mat-error
                    *ngIf="
                      individualForm.controls.state.touched &&
                      individualForm.controls.state.errors?.required
                    "
                  >
                    Estado obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-radio-group>
    </div>
  </div>

  <div class="buttons border-grey-light">
    <div class="form-row">
      <div class="cols">
        <div class="form-group mb-0">
          <button
            class="btn btn-block mb-3 btn-dark-primary-blue-pf"
            type="button"
            (click)="update()"
            [disabled]="individualForm.invalid || loading"
          >
            Avançar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
